module.exports = __webpack_public_path__ + "static/media/liuyanjianyi_140.6754117a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/liuyanjianyi_140.svg
// module id = 685
// module chunks = 0